import React from "react";
import { Heading, InputDropdown } from "@catchoftheday/cg-components";
import { useLocationSuggestionsDropdown } from "./useLocationSuggestionsDropdown.js";
export function LocationWidget({ title, label, initialLocation, onLocationSelected, }) {
    const titleElement = typeof title === "string" ? (<Heading.h5 mt={0} mb={3}>
        {title}
      </Heading.h5>) : (<>{title ? <div>{title}</div> : null}</>);
    const { data, setSearchTerm, setSelectedLocation, locations } = useLocationSuggestionsDropdown({
        initialLocation,
    });
    return (<div>
      {titleElement}
      <InputDropdown data={data} onInputChange={(value, reason) => {
            if (reason.onChange)
                setSearchTerm(value);
        }} onItemSelected={(item) => {
            const locationId = item?.value?.locationId;
            if (!locationId)
                return;
            setSelectedLocation(item?.title ?? "");
            const location = locations?.find((l) => l.id === locationId);
            if (!location) {
                console.error("LocationWidget: Location not found in list of locations.");
                return;
            }
            onLocationSelected?.(locationId, location);
        }} inputProps={{
            floatingLabelText: label ?? "Postcode or suburb",
            hoverBorderColor: "secondary",
            p: 4,
        }} defaultValue={initialLocation} clearInputOnFocus autoHighlightFirstItem/>
    </div>);
}
